import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { getAppUrl } from "../utils/utm";

export default function MeetCoach() {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });
  
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"]
  });
  
  const scale = useTransform(scrollYProgress, [0, 0.5], [0.9, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.3], [0.5, 1]);

  const appUrl = getAppUrl();

  return (
    <section className="relative meet-coach-section bg-[#F2FCDA] py-20" ref={sectionRef}>
      <div className="container mx-auto relative z-50 px-4" ref={ref}>
        <motion.div 
          className="relative bg-[#000000] meet-coach text-center p-10 md:p-20 rounded-3xl overflow-hidden"
          style={{ scale, opacity }}
          initial={{ y: 50 }}
          animate={inView ? { y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <motion.h1 
            className="text-[28px] md:text-[42px] lg:text-[65px] text-[#fff] font-bold mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Meet your new <span className="text-[#8ABB01]">Coach</span> today
          </motion.h1>
          <motion.p 
            className="text-[18px] text-[#fff] lg:text-[24px] mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Sign up today and meet your new coach within minutes. Start making
            real progress towards your goals. You deserve it.
          </motion.p>
          <motion.a
            href={appUrl}
            className="relative px-10 py-2 text-white text-[16px] md:text-[24px] bg-black h-[48px] md:h-[60px] lg:h-[75px] rounded-full text-center inline-flex items-center gap-4 border-solid border-2 md:border-4 border-[#8ABB01] z-50 hover:bg-[#8ABB01] hover:text-black transition-all duration-300"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={inView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.6 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Started
            <svg
              width="23"
              height="18"
              viewBox="0 0 23 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.49997 9.93762C1.25133 9.93762 1.01287 9.83885 0.837057 9.66303C0.661242 9.48722 0.562469 9.24876 0.562469 9.00012C0.562469 8.75148 0.661242 8.51302 0.837057 8.33721C1.01287 8.16139 1.25133 8.06262 1.49997 8.06262L13.0625 8.06262V1.50012C13.0626 1.31482 13.1177 1.13373 13.2207 0.979707C13.3238 0.825687 13.4701 0.705652 13.6413 0.634763C13.8125 0.563874 14.0009 0.54531 14.1826 0.581415C14.3644 0.617521 14.5314 0.706676 14.6625 0.837622L22.1625 8.33762C22.338 8.5134 22.4366 8.75168 22.4366 9.00012C22.4366 9.24856 22.338 9.48684 22.1625 9.66262L14.6625 17.1626C14.5314 17.2936 14.3644 17.3827 14.1826 17.4188C14.0009 17.4549 13.8125 17.4364 13.6413 17.3655C13.4701 17.2946 13.3238 17.1746 13.2207 17.0205C13.1177 16.8665 13.0626 16.6854 13.0625 16.5001L13.0625 9.93762L1.49997 9.93762Z"
                fill="#8ABB01"
              />
            </svg>
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
